import { RegularBusinessScopeEntity, } from "../../../entities";
import { Schema } from "../../../schema";
const RegularBusinessScopeRegistrationRequestLiteralList = ["scopes"];
export const RegularBusinessScopeRegistrationRequestSchema = () => Schema.pick({
    ...RegularBusinessScopeEntity.schema(),
}, RegularBusinessScopeRegistrationRequestLiteralList);
//# sourceMappingURL=regular-business-scopes-request.js.map